var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94286 3C7.52858 3 5.57143 4.95716 5.57143 7.37143C5.57143 9.7857 7.52858 11.7429 9.94286 11.7429C12.3571 11.7429 14.3143 9.7857 14.3143 7.37143C14.3143 4.95716 12.3571 3 9.94286 3Z",
    fill: "#0E9AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5226 13.6877C10.8136 13.4149 9.07213 13.4149 7.36313 13.6877L7.17994 13.7169C4.77189 14.1012 3 16.1783 3 18.6168C3 19.933 4.06698 21 5.38317 21H14.5025C15.8187 21 16.8857 19.933 16.8857 18.6168C16.8857 16.1783 15.1138 14.1012 12.7058 13.7169L12.5226 13.6877Z",
    fill: "#0E9AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1714 9.17143C18.5975 9.17143 18.9429 9.51681 18.9429 9.94286V11.2286H20.2286C20.6546 11.2286 21 11.574 21 12C21 12.426 20.6546 12.7714 20.2286 12.7714H18.9429V14.0571C18.9429 14.4832 18.5975 14.8286 18.1714 14.8286C17.7454 14.8286 17.4 14.4832 17.4 14.0571V12.7714H16.1143C15.6882 12.7714 15.3429 12.426 15.3429 12C15.3429 11.574 15.6882 11.2286 16.1143 11.2286H17.4V9.94286C17.4 9.51681 17.7454 9.17143 18.1714 9.17143Z",
    fill: "#0E9AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIconFilled);
export default __webpack_public_path__ + "static/media/usersIconFilled.715e3b5be291e915eedf81facbb26bfe.svg";
export { ForwardRef as ReactComponent };